<template>
  <div class="page-container">
    <div class="data-filter">
        <el-button size="mini" type="primary" @click="clientVersionSave">저장하기</el-button>
    </div>
    <div class="data-table">
        <el-form ref="" :model="server.form" :rules="server.rules">
            <el-table class="lmm-table" v-loading="loading" stripe border :data="list">
              <el-table-column type="index" :index="rowIndex" width="100"></el-table-column>
              <el-table-column label="에이전트 버전" width="300">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.win_agent_ver" style="width:200px;"></el-input>
                  </template>
              </el-table-column>
              <el-table-column label="뷰어 버전">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.win_viewer_ver" style="width:200px;"></el-input>
                </template>
              </el-table-column>
            </el-table>
        </el-form>
    </div>
  </div>
</template>

<script>
export default {
    methods: {
        async getClientVersionList () {
          console.log('GET CLIENT_VERSION')

          try {
            this.loading = true

            let response = await this.$http.get('client_version')
            this.list = response.data

            this.loading = false

            return response
          }
          catch (e) {
            console.error(e)
          }
        },
        rowIndex (index) {
            return index + 1
        },
        async clientVersionSave () {
          let params = this.list[0]
          let {status} = await this.$http.post('client_version', params)
          if (status === 200) {
              this.$service.$emit('alert-modal', '클라이언트 버전 정보가 수정되었습니다.')
          }else{
            console.log('error')
          }
        }
    },
    mounted () {
        this.getClientVersionList()
    },
    data () {
        return {
          loading: false,
          dialog_notice: false,
          dialog_notice_option: null,
          list: [],
          server: {
            loading: false,
            rules: {

            },
            form: {
              win_agent_ver: '',
              win_viewer_ver: ''
            }
          }
        }
    }
}
</script>

<style lang="scss" scoped>
.data-filter {
  padding: 10px 0;
  .data-filter-buttons {
    display: inline-block;
  }
  .data-filter-search {
    display: inline-block;
    padding-left: 15px;
  }
}
</style>